import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { AppSettings } from '../app-settings';

@Injectable({
  providedIn: 'root'
})
export class DiscountService {

  // Cambiar API
  constructor(private http: HttpClient) { }

  getBasicDiscountsByEvent(idEvent: any) { 
    const url = `${AppSettings.API_URI}/list/discounts/event/${idEvent}`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  postBasicDiscount(idEvent: any, payload: any) { 
    const url = `${AppSettings.API_URI}/create/basic/discount/event/${idEvent}`;
    return this.http.post<any>(url, payload).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  editDiscount(idDiscount: any, payload: any) { 
    const url = `${AppSettings.API_URI}/edit/basic/discount/${idDiscount}`;
    return this.http.put<any>(url, payload).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  getVenueDiscounts(idVenue: any) { 
    const url = `${AppSettings.API_URI}/list/discounts/venue/${idVenue}`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  getVenueDiscountByEvent(idEvent: any) { 
    const url = `${AppSettings.API_URI}/list/event/discounts/venue/${idEvent}`;
    return this.http.get<any>(url).pipe(
      map((data) => {
        return data
      }),
      catchError(err => { return throwError(() => err); })
    );
  }

  // ===== New v2 Discount CRUD endpoints =====

  getDiscountOptions() {
    const url = `${AppSettings.API_URI_V2}/discounts/options`;
    return this.http.get<any>(url).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }

  getDiscounts(idCompany?: number, search?: string) {
    const params: string[] = [];
    if (idCompany) params.push(`id_company=${idCompany}`);
    if (search) params.push(`search=${encodeURIComponent(search)}`);
    const url = `${AppSettings.API_URI_V2}/discounts${params.length ? '?' + params.join('&') : ''}`;
    return this.http.get<any>(url).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }

  getDiscountsByCompany(companyId: number, search?: string) {
    let url = `${AppSettings.API_URI_V2}/companies/${companyId}/discounts`;
    if (search) url += `?search=${encodeURIComponent(search)}`;
    return this.http.get<any>(url).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }

  getDiscountById(id: number) {
    const url = `${AppSettings.API_URI_V2}/discounts/${id}`;
    return this.http.get<any>(url).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }

  createDiscount(payload: any) {
    const url = `${AppSettings.API_URI_V2}/discounts`;
    return this.http.post<any>(url, payload).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }

  updateDiscount(id: number, payload: any) {
    const url = `${AppSettings.API_URI_V2}/discounts/${id}`;
    return this.http.put<any>(url, payload).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }

  toggleDiscountActive(id: number) {
    const url = `${AppSettings.API_URI_V2}/discounts/${id}/toggle-active`;
    return this.http.patch<any>(url, {}).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }

  deleteDiscount(id: number) {
    const url = `${AppSettings.API_URI_V2}/discounts/${id}`;
    return this.http.delete<any>(url).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }

  // ===== Promo Code endpoints =====

  validatePromoCode(cartId: number, code: string, channel?: number) {
    const url = `${AppSettings.API_URI_V2}/cart/${cartId}/promo-code/validate`;
    const body: any = { code };
    if (channel != null) body.channel = channel;
    return this.http.post<any>(url, body).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }

  applyPromoCode(cartId: number, code: string, channel?: number) {
    const url = `${AppSettings.API_URI_V2}/cart/${cartId}/promo-code`;
    const body: any = { code };
    if (channel != null) body.channel = channel;
    return this.http.post<any>(url, body).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }

  removePromoCode(cartId: number) {
    const url = `${AppSettings.API_URI_V2}/cart/${cartId}/promo-code`;
    return this.http.delete<any>(url).pipe(
      map((data) => data),
      catchError(err => throwError(() => err))
    );
  }
}
